export default __webpack_public_path__ + "static/media/not-avaliable.ab7a05e2.svg";